<template>
  <div class="o-page__sidebar js-page-sidebar">
    <div class="c-sidebar">
      <!-- <a class="c-sidebar__brand" href="/">
                <img class="c-sidebar__brand-img" src="/assets/img/logo.png" alt="Logo"> Dashboard
            </a> -->
      <div class="user__info">
        <div class="o-media">
          <div class="o-media__img u-mr-xsmall">
            <div class="c-avatar c-avatar--xsmall">
              <img class="c-avatar__img" :src="avatar" />
            </div>
          </div>
          <div class="o-media__body">
            {{ name }}<small class="u-block u-text-mute">{{ npp }}</small>
          </div>
        </div>
      </div>

      <h4 class="c-sidebar__title">Master Data</h4>
      <ul class="c-sidebar__list">
        <li class="c-sidebar__item" v-if="user_role_id == 1">
          <router-link class="c-sidebar__link" to="/" exact-active-class="is-active">
            <i class="el-icon-discover u-mr-xsmall"></i>Regions
          </router-link>
        </li>
        <li class="c-sidebar__item" v-if="user_role_id == 1">
          <router-link
            class="c-sidebar__link"
            to="/branches"
            exact-active-class="is-active"
          >
            <i class="el-icon-guide u-mr-xsmall"></i>Branches
          </router-link>
        </li>
        <li class="c-sidebar__item" v-if="user_role_id == 1">
          <router-link
            class="c-sidebar__link"
            to="/outlets"
            exact-active-class="is-active"
          >
            <i class="el-icon-map-location u-mr-xsmall"></i>Outlets
          </router-link>
        </li>
        <li class="c-sidebar__item">
          <router-link
            class="c-sidebar__link"
            to="/employees"
            exact-active-class="is-active"
          >
            <i class="el-icon-trophy-1 u-mr-xsmall"></i>Employees
          </router-link>
        </li>
        <li class="c-sidebar__item" v-if="user_role_id == 1">
          <router-link
            class="c-sidebar__link"
            to="/approval"
            exact-active-class="is-active"
          >
            <i class="el-icon-finished u-mr-xsmall"></i>Approval
          </router-link>
        </li>
        <li class="c-sidebar__item" v-if="user_role_id == 2">
          <router-link
            class="c-sidebar__link"
            to="/approval"
            exact-active-class="is-active"
          >
            <i class="el-icon-finished u-mr-xsmall"></i>Approval
          </router-link>
        </li>
      </ul>
      <h4 class="c-sidebar__title">Settings</h4>
      <ul class="c-sidebar__list">
        <li class="c-sidebar__item">
          <router-link
            class="c-sidebar__link"
            to="/profile"
            exact-active-class="is-active"
          >
            <i class="el-icon-user u-mr-xsmall"></i>Profile
          </router-link>
        </li>
        <li class="c-sidebar__item" v-if="user_role_id == 1">
          <router-link class="c-sidebar__link" to="/admin" exact-active-class="is-active">
            <i class="el-icon-setting u-mr-xsmall"></i>Admin
          </router-link>
        </li>
        <li class="c-sidebar__item" v-if="user_role_id == 1">
          <router-link class="c-sidebar__link" to="/logs" exact-active-class="is-active">
            <i class="el-icon-discover u-mr-xsmall"></i>Logs
          </router-link>
        </li>
        <li class="c-sidebar__item">
          <a @click="logout" class="c-sidebar__link u-text-danger">
            <i class="el-icon-switch-button u-mr-xsmall"></i>Logout
          </a>
        </li>
      </ul>
    </div>
    <!-- // .c-sidebar -->
  </div>
  <!-- // .o-page__sidebar -->
</template>

<script>
import { mapActions } from "vuex";

const baseURL = "https://api.squsp-datacenter.com";

export default {
  name: "sidebarmenu",
  data() {
    return {
      name: localStorage.getItem("name"),
      npp: localStorage.getItem("npp"),
      avatar: baseURL + localStorage.getItem("avatar"),
      user_role_id: localStorage.getItem("user_role_id"),
    };
  },
  methods: {
    ...mapActions(["logout"]),
  },
};
</script>

<style lang="scss" scoped>
.user__info {
  padding: 0.15rem 0.75rem;
  font-size: 0.8rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  background: #e2541b;
  color: white;
  .u-text-mute {
    color: white !important;
    opacity: 0.7 !important;
  }
}
.c-sidebar {
  background: #ffffff !important;
  border-right: 1px solid rgba(160, 175, 185, 0.15);
}
.c-sidebar__link {
  color: #5d676f;
}
.c-sidebar__item {
  padding: 0.15rem 0.75rem;
  .c-sidebar__link {
    border-radius: 3px;
    line-height: 2rem;
    padding: 0 0.5rem;
    &.is-active {
      color: #ffffff !important;
      background-color: #448bff !important;
    }
  }
}
</style>
